(function () {
  class FireballAnimation extends PIXI.Container {
    constructor() {
      super();

      this._whoosh = ["fireWhoosh1", "fireWhoosh2", "fireWhoosh3"];

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    onOrientationChange() {
      this._targetPos = this.findChild(
        this._posData.children[0].children,
        "fireball_secondPosEnd"
      );

      if (this._fireballContainer) {
        this._fireballContainer.x = this._targetPos.x;
        this._fireballContainer.y = this._targetPos.y;
      }
    }

    findChild(parent, name) {
      const child = parent.find(function (child) {
        return child.Props.ID === name;
      });
      return child;
    }

    onGameConfigEvent() {
      this._posData = this.findChild(this.children[0].children, "posData");

      this._targetPos = this.findChild(
        this._posData.children[0].children,
        "fireball_secondPosEnd"
      );

      this._fireballContainer = this.findChild(
        this.children[0].children,
        "fireballContainer"
      );

      if (this._fireballContainer) {
        this._fireballContainer.x = this._targetPos.x;
        this._fireballContainer.y = this._targetPos.y;
      }

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    animate(callback) {
      this._callback = callback;

      let ran = this.getRandomInt(30);
      let self = this;

      timerManager.addTimer(
        300,
        function () {},
        function () {
          self._callback();
        }
      );
    }

    stopLightning() {}

    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
  }

  var fireballAnimationCreator = function (json) {
    return new FireballAnimation();
  };

  var fireballAnimationInitialiser = function (json, fireballAnimation) {};

  var fireballAnimationFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "fireballAnimation",
    fireballAnimationCreator,
    fireballAnimationInitialiser,
    fireballAnimationFilesRequired
  );
})();
